// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ClusterOverviewItems {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto;\n  height: 60vh;\n  width: 100%; }\n\n.ClusterOverviewParent {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  height: 100vh; }\n\n.ClusterItem {\n  margin-top: 16px;\n  margin-bottom: 16px; }\n\n.CORightItem {\n  transform: translateY(50%); }\n\n.COLeftItem {\n  transform: translateY(1px); }\n", ""]);
// Exports
module.exports = exports;
